import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useHierarchyLabelsDrawerState } from './DrawerStateProvider';
import { HierarchyLabelForm } from './HierarchyLabelForm';

type Props = ComponentProps<typeof HierarchyLabelForm>;

export const HierarchyLabelFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useHierarchyLabelsDrawerState();

  return (
    <Drawer
      open={drawerState.open}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <HierarchyLabelForm initialValues={initialValues} onSubmit={onSubmit} />
    </Drawer>
  );
};
